module.exports = __webpack_public_path__ + "img/ft.bc058e29.jpg";